import React from 'react'

export interface IDividerProps {
  className?: string
}

/**
 * An unsemantic visual divider. To use a semantic divider we can either update
 * this component to add an addition prop flag or just use an hr atg
 *
 * @param props
 * @returns
 */
export const Divider: React.FC<IDividerProps> = ({ className }) => (
  <div
    className={`
      ds-u-border-top--1
      my-u-width--full
      my-u-p--0
      my-u-m--0
      ${className ?? ''}
    `}
  />
)
